import React from 'react'
import {  useAsyncDebounce } from 'react-table'
import IntlMessages from 'helpers/IntlMessages';
import { useIntl } from "react-intl";

const GlobalFilter = ({ globalFilter,  setGlobalFilter}) => {

    const [value, setValue] = React.useState(globalFilter)
    const onChange = useAsyncDebounce(values => {
        setGlobalFilter(values || undefined)
    }, 800)
    const intl = useIntl();
  return (
        <span>
            <input
                className="form-control"
                value={value || ""}
                onChange={e => {
                    setValue(e.target.value);
                    onChange(e.target.value);
                }}
                placeholder={intl.formatMessage({  id: 'menu.search1'})}
            />
        </span>
  )
}

export default GlobalFilter